// The black & white calendar's Web Address in Admin -> Calendar.
export const CALENDAR_BW_PATH = '/shop/calendar/dodging-shadows';

// Shared Shop dropdown items for the full-nav pages. `active` marks which
// item to highlight; pass '' if the current page isn't one of these.
export const SHOP_DROPDOWN = (active) => [
  { to: '/gallery', label: 'Beach Bum Gallery', active: active === 'gallery' },
  { to: '/shop/muggs', label: 'B.B. Muggs', active: active === 'muggs' },
  { to: '/shop/wicks', label: 'B.B. Wicks', active: active === 'wicks' },
  { to: '/shop/tees', label: 'Beach Bum Tees', active: active === 'tees' },
  { to: '/shop/notecards', label: 'Mostly Good Notecards', active: active === 'notecards' },
  { to: '/shop/mrsbum', label: 'Mrs. Bum', active: active === 'mrsbum' },
  { to: '/shop/calendar', label: 'Calendar', active: active === 'calendar' },
  { to: CALENDAR_BW_PATH, label: 'B&W Calendar', active: active === 'calendar-bw' },
];

// The main-menu "2027 Calendars" dropdown; `active` is 'calendar' or 'calendar-bw'.
export const CALENDAR_DROPDOWN = (active) => ({
  label: '2027 Calendars',
  dropdown: [
    { to: '/shop/calendar', label: 'Color Calendar', active: active === 'calendar' },
    { to: CALENDAR_BW_PATH, label: 'B&W Calendar', active: active === 'calendar-bw' },
  ],
});
